// Phase 4c: Wrapper für native fetch() mit Cookie-Auth + CSRF-Header.
//
// Statt
//   fetch('/api/foo', { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
// nutze
//   authFetch('/api/foo')
//
// Was authFetch macht:
// - `credentials: 'include'`: HttpOnly-Cookies werden gesendet (pb_access_token etc.)
// - X-CSRF-Token-Header: liest pb_csrf-Cookie und setzt ihn bei
//   state-changing Methoden (POST/PUT/PATCH/DELETE)
// - Default Content-Type bleibt was du angibst (oder application/json bei JSON-Body)
//
// Für komplexe Calls direkt die axios-Instance aus services/api.js nutzen —
// die hat alles eingebaut. authFetch ist nur für Bestandscode-Migration ohne
// API-Schema-Refactor.

const CSRF_PROTECTED_METHODS = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);

function getCsrfToken(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|;\s*)pb_csrf=([^;]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}

export async function authFetch(url: RequestInfo | URL, opts: RequestInit = {}): Promise<Response> {
  const method = (opts.method || 'GET').toUpperCase();
  const headers = new Headers(opts.headers || {});

  if (CSRF_PROTECTED_METHODS.has(method)) {
    const csrf = getCsrfToken();
    if (csrf && !headers.has('X-CSRF-Token')) {
      headers.set('X-CSRF-Token', csrf);
    }
  }

  return fetch(url, {
    ...opts,
    credentials: 'include',
    headers,
  });
}

export default authFetch;
